import { styled } from 'styled-components';

import { _useDispatch, _useSelector } from '@src/state/hooks';

import _chooseColor from '@src/io/events_out/_chooseColor';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;


  margin-top: 10pt;
  border: 2pt solid gray;
  padding-top: 10pt;
  padding-bottom: 10pt;

  width: 100%;
  min-width: 0;
  // overflow-y: scroll;

  // color hyperlink blue
  color: #0000ff;

  //background color windows 98 gray
  background-color: #c0c0c0;

`;

const ColorButton = styled.div<{ color: string }>`
  width: 50%;
  height: 10rem;
  background-color: ${(props) => props.color};
`;

type Props = {
  gameId: string;
};

export default function ChooseColor(props: Props) {
  const onSubmit = (color: string) => {
    console.log('choose color', color);
    _chooseColor(props.gameId, color);
  };

  return (
    <Container>
      <ColorButton color='red' onClick={() => onSubmit('red')} />
      <ColorButton color='blue' onClick={() => onSubmit('blue')} />
      <ColorButton color='green' onClick={() => onSubmit('green')} />
      <ColorButton color='white' onClick={() => onSubmit('white')} />
    </Container>
  );
}
